import { LegalDocumentPage } from "@/v2/components/LegalDocumentPage";
import { termsAndConditionsSections } from "./content";

export default function TermsAndConditions() {
  return (
    <LegalDocumentPage
      title="Terms and Conditions"
      subtitle="Please read these terms carefully before using this site."
      sections={termsAndConditionsSections}
    />
  );
}
